'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogueHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogueFooter from 'UIComponents/dialog/UIDialogFooter';
import VersionHistory from './VersionHistory';

const ThemeVersionHistoryPanel = props => {
  const {
    errorMessage,
    numVersions,
    offeringId,
    panelBodyHeader,
    panelFooter,
    panelHeader,
    panelSubheader,
    renderVersionActions,
    versionHistoryQuery
  } = props,
        panelProps = _objectWithoutPropertiesLoose(props, ["errorMessage", "numVersions", "offeringId", "panelBodyHeader", "panelFooter", "panelHeader", "panelSubheader", "renderVersionActions", "versionHistoryQuery"]);

  return /*#__PURE__*/_jsxs(UIModalPanel, Object.assign({}, panelProps, {
    children: [/*#__PURE__*/_jsx(UIDialogueHeader, {
      children: panelHeader
    }), panelSubheader, /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [panelBodyHeader, /*#__PURE__*/_jsx(VersionHistory, {
        errorMessage: errorMessage,
        numVersions: numVersions,
        offeringId: offeringId,
        renderVersionActions: renderVersionActions,
        versionHistoryQuery: versionHistoryQuery
      })]
    }), /*#__PURE__*/_jsx(UIDialogueFooter, {
      children: panelFooter
    })]
  }));
};

ThemeVersionHistoryPanel.propTypes = {
  errorMessage: PropTypes.string,
  numVersions: PropTypes.number,
  offeringId: PropTypes.number.isRequired,
  panelHeader: PropTypes.node.isRequired,
  panelSubheader: PropTypes.node,
  panelBodyHeader: PropTypes.node,
  panelFooter: PropTypes.node.isRequired,
  renderVersionActions: PropTypes.func,
  versionHistoryQuery: PropTypes.object
};
export default ThemeVersionHistoryPanel;